/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruletypeevent3Inputs */

const en_dropruletypeevent3 = /** @type {(inputs: Dropruletypeevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interested in the linked event`)
};

const de_dropruletypeevent3 = /** @type {(inputs: Dropruletypeevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interesse am verknüpften Event`)
};

/**
* | output |
* | --- |
* | "Interested in the linked event" |
*
* @param {Dropruletypeevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruletypeevent3 = /** @type {((inputs?: Dropruletypeevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruletypeevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruletypeevent3(inputs)
	return de_dropruletypeevent3(inputs)
});
export { dropruletypeevent3 as "dropRuleTypeEvent" }